module.exports = __webpack_public_path__ + "img/youtube.7242f102.png";